/**
 * Safari blocks programmatically opened new tabs (e.g. via anchor click with target="_blank")
 * when the click happens after an async operation. To work around this, Safari navigates in
 * the current tab while other browsers keep the new-tab behavior.
 */
export const isSafari = (): boolean => /^((?!chrome|android|crios|fxios|edg).)*safari/i.test(navigator.userAgent);

/**
 * Detect iPhone / iPad (including iPadOS 13+, which reports as "MacIntel" but exposes
 * multi-touch). The react-pdf / pdfjs viewer is unreliable on iOS Safari (e.g. older
 * versions lack `Promise.withResolvers`, even inside the pdf worker), so these devices
 * fall back to downloading the PDF directly instead of rendering it inline.
 */
export const isIOS = (): boolean =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

export const openUrl = (url: string): void => {
  if (isSafari()) {
    window.location.href = url;
    return;
  }

  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.target = '_blank';
  anchor.rel = 'noopener noreferrer';
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
};
